import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { getDefaultFontSize } from 'shared/hooks/useGetTypographyFonts';
import React from 'react';

export const UiContext = React.createContext({
  spacings: defaultSpacingPresets,
  getFontSize: getDefaultFontSize,
});
